import React from "react";
import Navbar from '../components/Navbar'
import PatientHeroSection from "../components/PatientHeroSection";
import HowItWorks from "../components/HowItWorks";
import Footer from "../components/Footer";
import TopSpecialties from "../components/TopSpecialties";
import { Helmet } from "react-helmet";
const ForPatients = () => {
    return (
        <div>
            <Helmet>
                <title> ForPatients - Doclivo</title>
                <meta name="description" content="Learn more about Your Company Name, the leading provider of automation and optimization solutions." />
                <meta name="keywords" content="about us, company, automation" />
            </Helmet>
            <Navbar></Navbar>
            <PatientHeroSection></PatientHeroSection>
            <HowItWorks></HowItWorks>
            <TopSpecialties></TopSpecialties>
            <Footer></Footer>
        </div>
    );
};

export default ForPatients;